module.exports = __webpack_public_path__ + "static/media/logo_only.c0ad3cd7.png";